/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["category{display:block;padding-top:70px;background-color:#fafafa}@media only screen and (max-width:1024px){category .hc-content{display:block}category .hc-content breadcrumbs{display:none}category .hc-content .category-articles .header .title{display:block}category .hc-content articles-order-select{margin-top:8px;margin-bottom:8px}}"];
export { styles as styles };
